// removed by extract-text-webpack-plugin
module.exports = {"backLink":"backLink__osCaP0REkPGS","sendLink":"sendLink__LV8mhY4Hi30G"};